import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../route.animation';

import {AuthenticationService} from '../../../_services/authentication.service';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {PageTitleService} from '../../../_services/page-title.service';
import {LocalStorageService} from '../../../_services/local-storage.service';

@Component({
	selector: 'app-login-two-factor-authentication',
	templateUrl: './login-two-factor-authentication.component.html',
	styleUrls: ['./login-two-factor-authentication.component.scss'],
	animations: [routeAnimation]
})

export class LoginTwoFactorAuthenticationComponent implements OnInit, OnDestroy {
	@HostBinding('@routeAnimation') routerTransition = true;

	public otpForm = this.formBuilder.group({
		sessionID: ['', Validators.required],
		code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
	});

	private _errorSubscription: Subscription = null;

	constructor(public authenticationService: AuthenticationService,
				private formBuilder: FormBuilder,
				private localStorageService: LocalStorageService,
				private pageTitleService: PageTitleService,
				public formService: FormsService) {
	}

	ngOnInit(): void {
		this.pageTitleService.setTitle('Twee-factor-authenticatie');
		this.formService.form = this.otpForm;

		this.otpForm.get('sessionID').setValue(this.localStorageService.get('sessionID'));

		this._errorSubscription = this.authenticationService.errors.subscribe(errors => {
			this.formService.processErrors(errors);
		});
	}

	submit(code: string): void {
		if (code.length === 6) {
			this.otpForm.controls.code.setValue(code);

			this.authenticationService.loginTwoFactorAuthentication(this.otpForm.value);
		}
	}

	ngOnDestroy() {
		if (this._errorSubscription !== null) {
			this._errorSubscription.unsubscribe();
		}
	}
}
